// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mensagem-form[data-v-3f39e451]{margin-top:20px;display:flex;flex-direction:column}.mensagem-form>*[data-v-3f39e451]{margin-bottom:10px}.saved-message[data-v-3f39e451]{margin-top:1rem;padding:1rem;border:1px solid #ccc;border-radius:4px}", ""]);
// Exports
module.exports = exports;
